/** Nom affiché : destinataire / saisie, puis compte client. */
export function orderDisplayName(order) {
    return (
        order?.user_name ||
        order?.get_datas_to_order_customer?.username ||
        order?.get_datas_to_order_customer?.name ||
        ''
    );
}

/**
 * Libellé du billet. Les liens custom n’ont pas de pivot :
 * ne jamais accéder à pivot_to_order.findthislabel sans optional chaining.
 */
export function orderTicketTitle(order) {
    return (
        order?.pivot_to_order?.findthislabel?.title ||
        order?.PivotToOrder?.findthislabel?.title ||
        order?.pass_name ||
        '—'
    );
}

export function orderSessionLabel(order) {
    if (!order) return null;
    if (order.session_display_label) return order.session_display_label;
    if (order.session_label) {
        const parts = [order.session_label, order.session_date ? formatSessionDateShort(order.session_date) : null].filter(Boolean);
        return parts.join(' · ') || order.session_label;
    }
    if (order.validity_type === 'full_event' && order.is_multi_session) {
        return 'Toute la durée';
    }
    const meta = parseOrderMetadata(order);
    if (meta?.session_label) {
        const parts = [meta.session_label, meta.session_date ? formatSessionDateShort(meta.session_date) : null].filter(Boolean);
        return parts.join(' · ') || meta.session_label;
    }
    if (meta?.validity_type === 'full_event' && meta?.is_multi_session) {
        return 'Toute la durée';
    }
    return null;
}

function formatSessionDateShort(raw) {
    if (!raw) return '';
    const d = new Date(raw.includes('T') ? raw : `${raw}T12:00:00`);
    if (Number.isNaN(d.getTime())) return raw;
    return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' });
}

function parseOrderMetadata(order) {
    const raw = order?.metadata;
    if (!raw) return null;
    if (typeof raw === 'object') return raw;
    if (typeof raw !== 'string') return null;
    try {
        return JSON.parse(raw);
    } catch {
        return null;
    }
}

/**
 * Prix payé vs tarif catalogue si l’achat a eu lieu pendant une promo.
 * Préfère les champs API (has_promo / original_total_price), sinon metadata.
 */
export function orderPromoTrace(order) {
    const paidTotal = Number(order?.total_price);
    const paidUnit = Number(order?.pass_price);
    const qty = Math.max(1, Number(order?.quantity) || 1);

    const apiOriginalTotal = Number(order?.original_total_price);
    if (order?.has_promo && Number.isFinite(apiOriginalTotal) && apiOriginalTotal > paidTotal) {
        return { hasPromo: true, originalTotal: apiOriginalTotal };
    }

    const apiOriginalUnit = Number(order?.original_unit_price);
    if (order?.has_promo && Number.isFinite(apiOriginalUnit) && apiOriginalUnit > paidUnit) {
        return { hasPromo: true, originalTotal: apiOriginalUnit * qty };
    }

    const meta = parseOrderMetadata(order);
    const metaOriginalUnit = Number(meta?.original_price);
    if (meta?.has_promo && Number.isFinite(metaOriginalUnit) && metaOriginalUnit > paidUnit) {
        return { hasPromo: true, originalTotal: metaOriginalUnit * qty };
    }

    const gross = Number(order?.gross_subtotal);
    if (Number.isFinite(gross) && Number.isFinite(paidTotal) && gross > paidTotal) {
        return { hasPromo: true, originalTotal: gross };
    }

    return { hasPromo: false, originalTotal: null };
}

/**
 * Paiement issu d’un lien direct (/l/{token}).
 */
export function orderPaymentLinkTrace(order) {
    const meta = parseOrderMetadata(order);
    const txId = String(order?.transaction_id || '');
    const isPaymentLink = Boolean(
        order?.from_payment_link
        || meta?.channel === 'payment_link'
        || txId.startsWith('PL-'),
    );
    const linkId = order?.payment_link_id || meta?.payment_link_id || null;

    return {
        isPaymentLink,
        linkId: linkId ? String(linkId) : null,
    };
}